<template>
  <fragment>
    <app-header title="Energy Providers">
      <template #actions>
        <router-link
          class="btn btn-primary mt-2 mt-xl-0"
          :to="{ name: 'settings.energy-providers.add' }"
        >
          <i class="far fa-plus"></i> Energy Provider
        </router-link>
      </template>
    </app-header>

    <div class="container my-4">

      <div class="card card-data-builder">

        <ul id="horizontal-nav" class="nav nav-horizontal">
          <li class="nav-item" :class="{ active: !archived }"><a class="nav-link" href="#" @click.prevent="archived = false">Published</a></li>
          <li class="nav-item" :class="{ active: archived }"><a class="nav-link" href="#" @click.prevent="archived = true">Archived</a></li>
        </ul><!-- /#horizontal-nav -->

        <c-data-list :items="filteredList" @load="load" class="">
          <template #default="{ item }">
            <router-link :to="{ name: 'settings.energy-providers.single', params: { providerId: item.id } }">
              <div class="row">
                <div class="col text-truncate">
                  <p>{{ item.name }}</p>
                </div>
                <div class="col-auto">
                  <button type="button" class="btn btn-sm text-warning" @click.prevent="handleArchive(item)">
                    <i class="far fa-trash-restore" v-if="item.archived"></i>
                    <i class="far fa-archive" v-else></i>
                  </button>
                </div>
              </div><!-- /.row -->
            </router-link>
          </template>
        </c-data-list>
      </div><!-- /.card -->
    </div>
  </fragment>
</template>
<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/energy-providers'
import { call } from 'vuex-pathify'
import swal from 'sweetalert'
import { http } from '@/utils'
import { compareQueryParams } from '@codium/codium-vue'

export default {
  mixins: [
    stateMapper
  ],

  data () {
    return {
      archived: false,
      params: null
    }
  },

  watch: {
    params: compareQueryParams()
  },

  computed: {
    ...helperComputed,

    filteredList () {
      return this.energyProviders.filter(({ archived }) => archived === this.archived)
    }
  },

  methods: {
    ...helperMethods,
    restoreEnergyProvider: call('settings/energyProviders/restoreEnergyProvider'),

    async load (done) {
      try {
        await this.getEnergyProviders()

        done()
      } catch {
        done(true)
      }
    },

    async handleArchive (item) {
      if (item.archived) {
        await this.restoreEnergyProvider(item)
        this.resetEnergyProvider()
        this.getEnergyProviders({ fresh: true })

        return true
      } else {
        try {
          await this.deleteEnergyProvider(item.id)
        } catch (error) {
          if (error.response && error.response.status === 409) {
            if (
              await swal({
                title: 'Confirmation required',
                text: error.response.data.message,
                buttons: {
                  ok: { text: 'Yes, delete', visible: true, className: 'btn btn-danger' },
                  cancel: { text: 'Cancel', visible: true, className: 'btn btn-outline-dark' }
                },
                closeOnClickOutside: false,
                dangerMode: true
              })
            ) {
              await http.delete(`/settings/energy-providers/${item.id}?confirmed=true`)
            }
          }
        }

        await this.getEnergyProviders({ fresh: true })
      }
    }
  }
}
</script>
